<template>
   
   <div class="special-highlights"
        v-if="numbers">
        <div class="selected-balls-highlight">
            <span class="heading float-left">{{ 'spot_hits' | translate }}</span>
            <span class="heading float-right">{{ 'spot_odds' | translate }}</span>
        </div>
       <div v-if="bettingSvc.ticket.input.length">
        <div class="paytable-row clearfix"
             v-for = "(row, key) in numbers"
             :key="key">
            <span class="float-left">{{key}}</span>
            <span class="float-right">{{row.toFixed(2)}}</span>
        </div>
       </div>
    </div>
    
</template>

<script>

import { translate } from '../../filters/translate';
import {BettingSvc} from '../../services/betting.service';
import {GameSvc} from '../../services/game.service';
import {PaytableSvc} from '../../services/paytable.service';


export default {
    name: "Paytable",
   
    filters: {
        translate,
    },

    data() {

        return {
           bettingSvc  : BettingSvc.getBettingSvc(),
           paytableSvc : PaytableSvc.getPaytableSvc(),
           gameSvc : GameSvc.getGameSvc()
        }
    },

    computed: {

      numbers() {

        let numbers;
        const selectedNumbers = this.bettingSvc.ticket.input.length;
          
        if (this.bettingSvc.type === 'system') {
            // System odds
            numbers = this.paytableSvc.paytable[this.bettingSvc.system + '_' + selectedNumbers];
        
        } else {

            if (this.bettingSvc.specialBetsActiveStatus[40] || this.bettingSvc.specialBetsActiveStatus[41]) {
                // All-In and No Draw odds
                numbers = {
                    [selectedNumbers]: parseFloat(sevenConfig.data.config.betOdds[this.bettingSvc.specialBetType].value[selectedNumbers - 1])
                }
            } else {
                // Spot odds
                numbers =  this.gameSvc.spotNumber >= selectedNumbers &&
                this.paytableSvc.paytable[selectedNumbers + '_' + selectedNumbers];
            }
        }

        return numbers;
       
       }
    }

}



</script>

<style lang="scss">


.special-highlights{
   
    width: 100%;

    .float-right {
        float: right;
    }

    .float-left {
        float: left;
    }
    
    
    .selected-balls-highlight{
        width: 90%;
        height: 3em;
        line-height: 3em;
        background: #3D3F41;
        color:#fff;
        font-weight: bold;
        margin-top: 10px;
        padding: 0 1em 0 1em;
        font-size: .75em;
        font-weight: 700;
        border-radius: 2px;
    }

    .paytable-row {
        width: 90%;
        height: 3em;
        line-height: 3em;
        background: #3D3F41;
        color:#fff;
        font-weight: bold;
        padding: 0 1em 0 1em;
        font-size: .75em;
        font-weight: 700;
        border-radius: 2px;
    }

   .paytable-row:nth-child(odd) {
      background: #242424;
      margin: 0;
    }
    .paytable-row:nth-child(even) {
      background: #303234;
      margin: 0;
    }

}

.heading {
    text-transform: uppercase;
}

</style>



// WEBPACK FOOTER //
// PayTable.vue?cef0271a